export default "__VITE_ASSET__DkAOmuw1__"